<div class="asf">
  <header class="asf__head">
    <h1 class="asf__title">
      <i class="fa-solid fa-user-graduate asf__icon" aria-hidden="true"></i>
      {{ 'FOLLOWING.ADMIN_TITLE' | translate }}
    </h1>
    <p class="asf__subtitle">{{ 'FOLLOWING.ADMIN_SUBTITLE' | translate }}</p>
  </header>

  <app-student-sessions-tab
    scope="all"
    sessionRouteBase="/admin/student-following"></app-student-sessions-tab>
</div>
